import { notifications } from '@mantine/notifications';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Interval, Task } from '@/types/types';

const useMoveToNewTask = ({ interval }: { interval: Interval }) => {
  const { axiosInstance } = useApi();

  const { project_id } = interval;

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ interval, newTaskId }: { interval: Interval; newTaskId: Task['id'] }) => {
      const { data } = await axiosInstance.put<Interval>(
        '/api/v1/intervals/move_to_new_task',
        {},
        {
          params: {
            id: interval.id,
            new_task_id: newTaskId,
          },
        }
      );
      return data;
    },

    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.planningProjects._def,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.resources.byProject(project_id).queryKey,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.resources.byGrouped._def,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tasks.detail(data.task_id).queryKey,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.intervals._def,
      });

      notifications.show({
        title: 'Succes',
        message: 'Interval blev flyttet',
        color: 'green',
      });
    },
    onError: () => {
      notifications.show({
        title: 'Fejl',
        message: 'Kunne ikke flytte interval',
        color: 'red',
      });
    },
  });
};

export default useMoveToNewTask;
